export default "__VITE_ASSET__f5d23328__"